<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de Gastos</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>
    </div>

    <ng-container *ngIf="!isSearching && item != null">

      <ng-container *ngIf="item.Editable">

        <div *ngIf="canEditComunidad && canEditUf" fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center" style="margin-bottom: 10px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 8px;">
            <mat-label style="font-weight: bold; font-size: 16px;">¿A qué le vas a cargar un gasto?</mat-label>
          </div>
          <br />
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <button mat-raised-button (click)="loadComunidadView()" [disabled]="isSaving || isDeleting" class="zb-button"
                [ngStyle]="{ 'background-color': esGastoComunidad === true ? '#ffd000' : '#fff'}">
                A {{('Comunidad' | translate).toLowerCase()}}
              </button>
              <button mat-raised-button (click)="loadUfView()"  [disabled]="isSaving || isDeleting" class="zb-button"
                [ngStyle]="{ 'background-color': esGastoUf === true ? '#ffd000' : '#fff'}">
                A {{('UnidadFuncional' | translate).toLowerCase()}}
              </button>
            </div>
          </div>

          <hr style="margin: 10px 0px; width: 100%;">

        </div>

        <form [formGroup]="formGroup" *ngIf="esGastoComunidad || esGastoUf">

          <!-- SELECCION DE COMUNIDAD / UF -->
          <mat-expansion-panel [expanded]="true" hideToggle="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">business</mat-icon> Selecciona una
                {{esGastoComunidad ? ('Comunidad' | translate).toLowerCase() : ''}}{{esGastoUf ? ('UnidadFuncional' | translate).toLowerCase() : ''}} a la cual le cargarás el gasto
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <ng-container *ngIf="canEditComunidad && esGastoComunidad">

              <div fxLayout="row stretch" class="zb-readonly" fxLayoutAlign="center center">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                    <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                    <mat-select formControlName="Comunidad" [compareWith]="compareComunidad" (selectionChange)="onComunidadSelect()">
                      <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="!formGroup.controls['Comunidad'].valid && formGroup.controls['Comunidad'].touched">
                      {{ getErrorComunidad() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                </div>

              </div>

            </ng-container>

            <ng-container *ngIf="canEditUf && esGastoUf">

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
                <button mat-raised-button (click)="onUfSelect()" [disabled]="isSaving || isDeleting" color="primary" class="zb-button">
                  <i class="fa fa-search" style="margin-right: 5px;"></i>Seleccionar {{'UnidadFuncional' | translate}}
                </button>
              </div>

              <div fxLayout="row stretch" class="zb-readonly" *ngIf="itemUf != null && itemUf.Id > 0">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Código</b>: {{itemUf?.Codigo}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Número</b>: {{itemUf?.Numero}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Cantidad Ambientes</b>: {{itemUf?.CantidadAmbientes}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Tipo Unidad</b>: {{itemUf?.TipoUnidadNombre}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>{{'Comunidad' | translate}}</b>: {{itemUf?.Comunidad}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Número Piso</b>: {{itemUf?.NroPiso}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Consorcio</b>: {{itemUf?.Consorcio}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Observaciones</b>: {{itemUf?.Observaciones}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </div>

            </ng-container>

          </mat-expansion-panel>

          <br/>

          <!-- DATOS DEL GASTO -->
          <mat-expansion-panel [expanded]="true" hideToggle="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">description</mat-icon>Ingrese los datos del gasto a cargar
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- ANALISIS DE ARCHIVO -->
            <ng-container *ngIf="canAnalizarDoc">

              <br />

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">

                  <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #d0eeff;">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label class="text-style" style="font-weight: bold; text-align: center;">
                        ¿Queres cargar los datos del gasto automáticamente desde un archivo?
                      </mat-label>
                    </div>

                    <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
                      <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">
                        <button mat-icon-button matSuffix (click)="adjuntoAnalisisInput.click()" *ngIf="!isFileAttaching && !isFileAnalyzing" style="width: 100%;">
                          <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Analizalo acá.
                        </button>
                        <input hidden (change)="onFileAttachForAnalyze($event)" #adjuntoAnalisisInput type="file">
                        <mat-label *ngIf="isFileAttaching"><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
                        <mat-label *ngIf="isFileAnalyzing"><i class="fa fa-spinner fa-spin"></i> Analizando archivo...</mat-label>
                      </div>
                    </div>
                  </mat-expansion-panel>

                </div>

              </div>

            </ng-container>

            <!-- DATOS DEL GASTO -->
            <div fxLayout="row stretch" class="zb-readonly" fxLayoutAlign="center center">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoGastoComunidadSearching">Tipo de Gasto*</mat-label>
                  <mat-label *ngIf="isTipoGastoComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoGastoComunidad" (selectionChange)="onTipoGastoComunidadSelect()"
                    [compareWith]="compareTipoGastosComunidad">
                    <mat-option *ngFor="let s of comunidadTipoGastoList" [value]="s">{{s.TipoGasto}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['TipoGastoComunidad'].valid && formGroup.controls['TipoGastoComunidad'].touched">
                    {{ getErrorTipoGastoComunidad() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadTipoGastoServicioSearching">Servicio*</mat-label>
                  <mat-label *ngIf="isComunidadTipoGastoServicioSearching">Cargando...</mat-label>
                  <mat-select formControlName="ServicioGastoId">
                    <mat-option *ngFor="let s of comunidadTipoGastoServicioList" [value]="s.Id">{{s.Nombre}}
                      <!-- ({{s.CategoriaGastoNombre}}) -->
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['ServicioGastoId'].valid && formGroup.controls['ServicioGastoId'].touched">
                    {{ getErrorServicioGastoId() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Detalle*</mat-label>
                  <input matInput formControlName="Detalle" (keyup.enter)="onGuardar()" maxlength="150">
                  <mat-error *ngIf="!formGroup.controls['Detalle'].valid && formGroup.controls['Detalle'].touched">
                    {{ getErrorDetalle() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Gasto*</mat-label>
                  <input matInput [matDatepicker]="fechaGastoPicker" formControlName="FechaGasto"
                    (click)="fechaGastoPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGasto')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaGastoPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                  <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select formControlName="MonedaId">
                    <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['MonedaId'].valid && formGroup.controls['MonedaId'].touched">
                    {{ getErrorMonedaId() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Vencimiento*</mat-label>
                  <input matInput [matDatepicker]="fechaVencimientoPicker" formControlName="FechaVencimiento"
                    (click)="fechaVencimientoPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix
                    (click)="clearDate('FechaVencimiento')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                  <mat-error
                    *ngIf="!formGroup.controls['FechaVencimiento'].valid && formGroup.controls['FechaVencimiento'].touched">
                    {{ getErrorFechaVencimiento() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Importe Base*</mat-label>
                  <input matInput type="number" formControlName="ImporteBase" (change)="calcularMontos()" (keyup.enter)="onGuardar()" (wheel)="onWheel($event)">
                  <mat-error *ngIf="!formGroup.controls['ImporteBase'].valid && formGroup.controls['ImporteBase'].touched">
                    {{ getErrorImporte() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Segunda Fecha Vencimiento</mat-label>
                  <input matInput [matDatepicker]="fechaVencimiento2Picker" formControlName="FechaVencimiento2" readonly
                    (click)="fechaVencimiento2Picker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimiento2Picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix
                    (click)="clearDate('FechaVencimiento2')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimiento2Picker></mat-datepicker>
                  <mat-error
                    *ngIf="!formGroup.controls['FechaVencimiento2'].valid && formGroup.controls['FechaVencimiento2'].touched">
                    {{ getErrorFechaVencimiento2() }}
                  </mat-error>
                </mat-form-field>
              </div> -->
              <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Importe Base Segundo Vencimiento</mat-label>
                  <input matInput type="number" formControlName="ImporteBase2" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['ImporteBase2'].valid && formGroup.controls['ImporteBase2'].touched">
                    {{ getErrorImporte2() }}
                  </mat-error>
                </mat-form-field>
              </div> -->

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isAlicuotaIvaSearching">IVA{{tenantFeatureFlags?.HabilitarControlCaja ? "*" : ""}}</mat-label>
                  <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                  <mat-select formControlName="AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect()">
                    <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
                    {{ getErrorAlicuotaIvaId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>IVA</b>: {{montoIva1 | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <!-- <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>IVA 2</b>: {{montoIva2 | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div> -->

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Total</b>: {{montoTotal1 | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <!-- <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Total 2</b>: {{montoTotal2 | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div> -->
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                    [matAutocomplete]="proveedor" formControlName="Proveedor">
                  <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                    class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                  <mat-error *ngIf="!formGroup.controls['Proveedor'].valid && formGroup.controls['Proveedor'].touched">
                    {{ getErrorProveedor() }}
                  </mat-error>
                </mat-form-field>
                <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                  <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                    {{s.RazonSocial }}
                  </mat-option>
                </mat-autocomplete>

              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item != null && item.Id > 0 && item.UnidadFuncionalId > 0 && item.ExpensaCabeceraGeneradoraId > 0">
                <mat-checkbox formControlName="PermitirGenerarInteres" (keyup.enter)="onGuardar()" color="primary">Permitir Generar Interés</mat-checkbox>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Observaciones</mat-label>
                  <textarea matInput formControlName="Observaciones"></textarea>
                  <mat-error
                    *ngIf="!formGroup.controls['Observaciones'].valid && formGroup.controls['Observaciones'].touched">
                    {{ getErrorObservaciones() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

            <!-- GASTOS RECURRENTES -->
            <ng-container *ngIf="canRecurrente">

              <hr style="margin: 10px 0px; width: 100%;">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                  <mat-checkbox formControlName="EsRecurrente" (keyup.enter)="onGuardar()" color="primary">¿Es un gasto recurrente?</mat-checkbox>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="formGroup?.get('EsRecurrente')?.value == true">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Periodicidad de Recurrencia (días)*</mat-label>
                    <input matInput type="number" formControlName="PeriodicidadRecurrencia" (keyup.enter)="onGuardar()" maxlength="10">
                    <!-- <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                      {{ getErrorNombre() }}
                    </mat-error> -->
                  </mat-form-field>
                </div>

              </div>

            </ng-container>

          </mat-expansion-panel>

          <br/>

          <!-- ADJUNTOS -->
          <mat-expansion-panel [expanded]="true" hideToggle="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">attach_file</mat-icon>Adjuntos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of item.Adjuntos">

              <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;">
                <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                  <i class="fa fa-trash fa-1x"></i>
                </button>
              </div>
              <div fxFlex=65 fxFlex.xs=95 class="flex-item" style="padding: 14px 10px; background-color: lightgray; margin-top: 10px; border-radius: 10px;">
                <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
              </div>
              <div fxFlex=30 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <mat-checkbox [(ngModel)]="file.PermitirAccederPublicamente" [ngModelOptions]="{standalone: true}">Permitir ver públicamente</mat-checkbox>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
                <button mat-icon-button matSuffix (click)="fileInput.click()" [disabled]="isFileAttaching">
                  <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto
                </button>
                <input hidden (change)="onNewFileAttach($event)" #fileInput type="file" multiple>
                <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...
                </mat-label>
              </div>

            </div>

          </mat-expansion-panel>

        </form>

      </ng-container>

      <ng-container *ngIf="!item.Editable">

        <!-- DATOS DEL GASTO -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos del Gasto
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Gasto</b>: {{item.FechaGasto | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Gasto</b>: {{item.TipoGasto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Servicio</b>: {{item.ServicioGastoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Detalle</b>: {{item.Detalle}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{item.Observaciones}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Moneda</b>: {{item.MonedaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Vencimiento</b>: {{item.FechaVencimiento | date: 'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe Base</b>: {{item.ImporteBase | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Segundo Vencimiento</b>: {{item.FechaVencimiento2 | date: 'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> -->
            <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe Base Segundo Vencimiento</b>: {{item.ImporteBase2 | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> -->

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>IVA</b>: {{item.AlicuotaIvaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>IVA</b>: {{item?.ImporteAlicuotaIva | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>IVA 2</b>: {{item?.ImporteAlicuotaIva2 | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> -->
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Proveedor</b>: {{item.ProveedorNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Permitir Generar Interés</b>: {{item.PermitirGenerarInteres ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <hr style="margin: 10px 0px; width: 100%;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Es Recurrente</b>: {{item.EsRecurrente ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.EsRecurrente">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Periodicidad de Recurrencia (días)</b>: {{item.PeriodicidadRecurrencia | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <!-- DATOS DE COMUNIDAD -->
        <ng-container *ngIf="item.ComunidadId != null && item.ComunidadId > 0">

          <br />

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de {{'Comunidad' | translate}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="isGastoComunidadSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isGastoComunidadSearching">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Nombre</b>: {{itemComunidad?.Nombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Tipo</b>: {{itemComunidad?.TipoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Cant. Pisos</b>: {{itemComunidad?.CantidadPisos}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Consorcio</b>: {{itemComunidad?.ConsorcioNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Dirección</b>: {{itemComunidad?.Direccion}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <!-- DATOS DE UF -->
        <ng-container *ngIf="item.UnidadFuncionalId != null && item.UnidadFuncionalId > 0">

          <br />

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de Unidad Funcional
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="isGastoUfSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isGastoUfSearching">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Código</b>: {{itemUf?.Codigo}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Número</b>: {{itemUf?.Numero}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>{{'Comunidad' | translate}}</b>: {{itemUf?.Comunidad}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Consorcio</b>: {{itemUf?.Consorcio}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Tipo Unidad</b>: {{itemUf?.TipoUnidadNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Ambientes</b>: {{itemUf?.CantidadAmbientes}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <br />

        <!-- ADJUNTOS -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="!isAttachmentSearching">
              <mat-nav-list>
                <mat-list-item *ngFor="let file of item.Adjuntos"
                  style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                  <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                </mat-list-item>
              </mat-nav-list>
            </div>
          </div>

        </mat-expansion-panel>

      </ng-container>

      <!-- Datos de Expensa Liquidada -->
      <ng-container *ngIf="item.ExpensaCabeceraId != null && item.ExpensaCabeceraId > 0 && canExpensaView">

        <br/>

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Datos de Expensa
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="isExpensaLiquidacionSearching">
            <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isExpensaLiquidacionSearching">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{'Comunidad' | translate}}</b>: {{expensaCabecera.ComunidadNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Período</b>: {{expensaCabecera.ExpensaPeriodo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{expensaCabecera.Observaciones}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Vencimiento</b>: {{expensaCabecera.FechaVencimiento | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe</b>: {{expensaCabecera.MonedaCodigo}} {{expensaCabecera.Importe | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Segundo Vencimiento</b>: {{expensaCabecera.FechaVencimiento2 | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe 2do. Venc.</b>: {{expensaCabecera.MonedaCodigo}} {{expensaCabecera.Importe2 | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Interés Vencimiento</b>: {{expensaCabecera.InteresVencimiento | number: '1.2-2'}}%</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Interés Mensual</b>: {{expensaCabecera.InteresMensual | number: '1.2-2'}}%</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

          </div>

          <div fxLayout="row-reverse stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="onViewExpensa(expensaCabecera.Id)" [disabled]="isSaving || isDeleting" color="primary" class="zb-button">Ver Detalle de Expensa</button>
          </div>

        </mat-expansion-panel>

      </ng-container>

      <!-- Movimientos -->
      <ng-container *ngIf="item != null && item.Id > 0 && item.Activo && canMovimientoView">

        <br/>

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">attach_money</mat-icon> Movimientos Asociados
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
            <button mat-raised-button (click)="onCrearMovimiento()" color="primary" class="zb-button" [disabled]="isDeudaSaving" *ngIf="movimientoList == null || movimientoList.length == 0">
              {{isDeudaSaving ? 'Generando...' : 'Generar Movimiento'}}
            </button>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isMovimientosSearching">Buscando...</mat-label>
              <ejs-grid #grid [dataSource]='movimientoList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='FechaMovimiento' headerText='Fecha' width=90 type='date'>
                    <ng-template #template let-data>
                      {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
                    </ng-template>
                  </e-column>
                  <e-column field='FechaVencimiento' headerText='Vencimiento' width=90 type='date'>
                    <ng-template #template let-data>
                      {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                    </ng-template>
                  </e-column>
                  <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
                  <e-column field='Detalle' headerText='Detalle' width=100></e-column>
                  <!-- <e-column field='MedioPagoNombre' headerText='Medio de Pago' width=90></e-column> -->
                  <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
                    <ng-template #template let-data>
                      {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                    </ng-template>
                  </e-column>
                  <!-- <e-column field='AlicuotaIvaNombre' headerText='IVA' width=50></e-column> -->
                  <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70>
                    <ng-template #template let-data>
                      {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width=50>
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="viewMovimiento(data)"><i class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

    </ng-container>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <ng-container *ngIf="(esGastoComunidad || esGastoUf) && item?.Editable">
        <button mat-raised-button (click)="onStep2Guardar()" [disabled]="isSaving || isDeleting" color="primary" class="zb-button">
          {{isSaving ? 'Guardando...' : 'Guardar'}}
        </button>
        <button mat-raised-button (click)="openDialogCargaMovimiento(true)" [disabled]="isSaving || isDeleting" *ngIf="tenantFeatureFlags?.HabilitarControlCaja && !tieneMovimientoAsociado()"
          class="zb-button">
          {{isSaving ? 'Guardando...' : 'Guardar y Configurar Cuotas'}}
        </button>
      </ng-container>

      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">
        {{canAdd || canEdit || item?.Editable ? 'Cancelar' : 'Cerrar'}}
      </button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0 && item?.Editable" [disabled]="isSaving || isDeleting" color="accent" class="zb-button">
        {{isDeleting ? 'Procesando...' : 'Dar de Baja el Gasto'}}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
